export default __webpack_public_path__ + "static/media/JuJia.9dbe497e.jpg";